export enum WeightUnit {
  KILOGRAMS = 'kg',
  POUNDS = 'lbs',
}

export interface Weight {
  value: number;
  unit: WeightUnit;
}
